(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["memys-account-guided"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('memys-account-guided')) {
    let accountPanelSequence = 0;

    class MemysAccountGuided extends HTMLElement {
      connectedCallback() {
        if (this.accountEvents) return;
        const dialog = this.querySelector('[data-account-dialog]');
        const trigger = this.querySelector('[data-account-open]');
        const close = this.querySelector('[data-account-close]');
        if (!dialog || !trigger || !close) return;
        if (typeof dialog.showModal !== 'function') return;

        this.accountEvents = new AbortController();
        const options = { signal: this.accountEvents.signal };
        const sequence = ++accountPanelSequence;
        dialog.id = 'memys-account-dialog-' + sequence;
        trigger.setAttribute('aria-controls', dialog.id);

        const positionDialog = () => {
          if (window.matchMedia('(min-width: 750px)').matches) {
            const triggerRect = trigger.getBoundingClientRect();
            const top = Math.max(16, Math.min(triggerRect.bottom + 12, window.innerHeight - dialog.offsetHeight - 16));
            const right = Math.max(16, Math.min(window.innerWidth - triggerRect.right, window.innerWidth - dialog.offsetWidth - 16));
            dialog.style.setProperty('--memys-account-top', top + 'px');
            dialog.style.right = right + 'px';
          } else {
            dialog.style.removeProperty('right');
          }
        };

        trigger.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (dialog.open) return;
          const shopTemplate = this.querySelector('[data-account-shop]');
          if (shopTemplate instanceof HTMLTemplateElement) shopTemplate.replaceWith(shopTemplate.content.cloneNode(true));
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
          positionDialog();
        }, options);

        close.addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);

        dialog.addEventListener('close', event => {
          if (event.target !== dialog) return;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus({ preventScroll: true });
        }, options);

        window.addEventListener('resize', () => { if (dialog.open) positionDialog(); }, options);
      }

      disconnectedCallback() {
        const dialog = this.querySelector('[data-account-dialog]');
        if (dialog?.open) dialog.close();
        this.accountEvents?.abort();
        this.accountEvents = null;
      }
    }

    customElements.define('memys-account-guided', MemysAccountGuided);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["memys-cart-shipping"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-memys-cart-welcome]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href);
    if (location.pathname === target.pathname && location.search === target.search) {
      event.preventDefault();
      location.replace(target.href);
      location.reload();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["memys-help"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-memys-help]');
    if (!root) return;
    const small = matchMedia('(max-width: 849px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const header = document.querySelector('#header-group');
    const toc = root.querySelector('.mh-toc-disclosure');
    const links = [...root.querySelectorAll('.mh-toc a')];
    const headings = [...root.querySelectorAll('.mh-article h2[id]')];
    const setHeaderOffset = () => document.body.style.setProperty('--mh-offset', `${Math.ceil(header?.getBoundingClientRect().height || 0) + 18}px`);
    if (header) new ResizeObserver(setHeaderOffset).observe(header);
    setHeaderOffset();
    const adaptContents = () => { if (toc) toc.open = !small.matches; };
    small.addEventListener('change', adaptContents);
    adaptContents();
    const markCurrent = (id) => links.forEach(link => { if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
    let scheduled = false;
    const updateCurrent = () => {
      scheduled = false;
      if (!headings.length) return;
      const threshold = (header?.getBoundingClientRect().height || 0) + 64;
      let active = headings[0];
      for (const heading of headings) { if (heading.getBoundingClientRect().top <= threshold) active = heading; else break; }
      markCurrent(active.id);
    };
    document.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateCurrent); } }, {passive: true});
    links.forEach(link => link.addEventListener('click', event => {
      const heading = document.getElementById(link.hash.slice(1));
      if (!heading) return;
      event.preventDefault();
      if (small.matches && toc) toc.open = false;
      history.pushState(null, '', link.hash);
      heading.focus({preventScroll: true});
      requestAnimationFrame(() => { heading.scrollIntoView({block: 'start', behavior: reduced.matches ? 'instant' : 'smooth'}); markCurrent(heading.id); });
    }));
    updateCurrent();
    const menus = [...document.querySelectorAll('.mh-header details')];
    menus.forEach(menu => menu.addEventListener('toggle', () => { if (menu.open) menus.forEach(other => {if (other !== menu) other.open = false;}); }));
    document.addEventListener('keydown', event => { if (event.key !== 'Escape') return; menus.forEach(menu => {if (menu.open) {menu.open = false; menu.querySelector('summary')?.focus();}}); });
    document.addEventListener('click', event => {if (!event.target.closest('.mh-header')) menus.forEach(menu => {menu.open = false;});});
    const printOpen = new Map();
    addEventListener('beforeprint', () => root.querySelectorAll('.mh-faq-list details').forEach(detail => {printOpen.set(detail, detail.open);detail.open = true;}));
    addEventListener('afterprint', () => {printOpen.forEach((open, detail) => {detail.open = open;});printOpen.clear();});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["memys-mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = matchMedia('(max-width: 749px)');
    const drawer = () => document.querySelector('header-drawer[data-memys-mobile-host]');
    const details = () => drawer()?.querySelector('details.menu-drawer-container');
    const setView = (view) => {
      const host = drawer();
      if (!host) return;
      host.querySelector('[data-memys-buy]').hidden = view !== 'buy';
      host.querySelector('[data-memys-help]').hidden = view !== 'help';
      host.querySelectorAll('[data-memys-nav] [data-memys-action]').forEach((link) => {
        if (link.dataset.memysAction === view) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      host.dataset.memysView = view;
    };
    const close = () => new Promise((resolve) => {
      const host = drawer();
      const menu = details();
      if (!host || !menu?.open) { resolve(); return; }
      let timer;
      const finish = () => { clearTimeout(timer); menu.removeEventListener('toggle', onToggle); resolve(); };
      const onToggle = () => { if (!menu.open) finish(); };
      menu.addEventListener('toggle', onToggle);
      timer = setTimeout(finish, 800);
      if (typeof host.close === 'function') host.close();
      else menu.querySelector('summary')?.click();
    });
    const open = (view) => {
      const menu = details();
      if (!menu) return false;
      setView(view);
      if (!menu.open) menu.querySelector('summary')?.click();
      return true;
    };
    document.addEventListener('click', async (event) => {
      if (!mobile.matches || !(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-memys-action]');
      if (!trigger) return;
      if (event instanceof MouseEvent && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
      const action = trigger.dataset.memysAction;
      if (action === 'buy' || action === 'help') {
        if (open(action)) event.preventDefault();
        return;
      }
      if (action === 'home') {
        if (location.pathname === new URL(trigger.href).pathname) { event.preventDefault(); await close(); }
        return;
      }
      let original;
      if (action === 'search') original = document.querySelector('header search-button button[aria-haspopup="dialog"]');
      if (action === 'account') original = document.querySelector('header [data-account-open]');
      if (action === 'cart') original = document.querySelector('header [data-testid="cart-drawer-trigger"]');
      if (original instanceof HTMLElement) {
        event.preventDefault();
        await close();
        original.click();
      }
    });
    document.addEventListener('toggle', (event) => {
      const menu = details();
      if (event.target !== menu) return;
      document.querySelectorAll('[data-memys-nav] [data-memys-action="buy"],[data-memys-nav] [data-memys-action="help"]').forEach((link) => link.setAttribute('aria-expanded', String(menu.open)));
      if (!menu.open) {
        if (drawer()?.contains(document.activeElement)) menu.querySelector('summary')?.focus({preventScroll:true});
        setView('buy');
      }
    }, true);
    mobile.addEventListener('change', () => { if (!mobile.matches) close(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
